<template>
    <mdb-tbl>
      <mdb-tbl-head>
        <tr>
          <th style="font-weight: bold">Id</th>
          <th style="font-weight: bold">Date ordered</th>
          <th style="font-weight: bold">Date completed</th>
          <th style="font-weight: bold">Task name</th>
          <th style="font-weight: bold">Task type</th>
          <th style="font-weight: bold">Date of payment</th>
          <th style="font-weight: bold">Payment</th>
          <th style="font-weight: bold">Payable</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body class="main" v-if="(taskHistory instanceof Array)">
        <tr v-for="(task, index) in taskHistory" v-bind:key="index">
          <td>{{ task.taskid }}</td>
          <td>
            {{ task.dateadded }}
          </td>
          <td>
            {{ task.datecompleted }}
          </td>
          <td>
            {{ task.name }}
          </td>
          <td>
            {{ task.type }}
          </td>
          <td>
            {{ task.dateofpayment }}
          </td>
          <td>
            {{ task.payment }}
          </td>
          <td>
            <span style="color: lightgreen" v-if="task.isPayable && !task.dateofpayment">Payable</span>
            <span v-else-if="task.dateofpayment">Paid</span>
            <span v-else>Not Payable</span>
          </td>
          <td>
            <mdb-btn v-if="task.has_qa_comments" @click="$emit('check-review-comments', task.taskid)">Check Review Comments</mdb-btn>
          </td>
        </tr>
      </mdb-tbl-body>
      <mdb-tbl-body v-else>
        <tr>
          <td colspan="7" >
            <mdb-spinner  multicolor />
          </td>
        </tr>
      </mdb-tbl-body>
      <tfoot>
        <tr class="text-center">
          <td colspan="7" class="text-center w-100">
            <mdb-pagination class="text-center w-100 justify-content-center">
              <mdb-btn
                prev
                @click.native="$emit('changePage', currentPage - 1)"
                :disabled="currentPage === 1 || taskHistory === null"
              >Previous</mdb-btn>

              <mdb-btn
                next
                @click.native="$emit('changePage', currentPage + 1)"
                :disabled="currentPage === totalPages || taskHistory === null"
              >Next</mdb-btn>
            </mdb-pagination>
          </td>
        </tr>
      </tfoot>
    </mdb-tbl>
</template>

<script>
import {
  mdbBtn,
  mdbPagination,
  mdbSpinner,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
} from 'mdbvue';

export default {
  components: {
    mdbBtn,
    mdbPagination,
    mdbSpinner,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
  },

  props: {
    taskHistory: null,
    currentPage: null,
    totalPages: null,
  },
};
</script>

<style>
</style>
